const { defaultLanguage, langPrefixes } = require("../../prismic-configuration")

/**
 * Get the URL prefix for a given language code
 * @param {string} lang - Prismic language code (e.g., 'en-gb', 'ar-ae')
 * @returns {string} URL prefix (e.g., '', 'ar')
 */
const getLangPrefix = (lang) => {
  // Handle null/undefined lang (common for internal links)
  if (!lang || lang === defaultLanguage) return ""
  return langPrefixes[lang] || lang.split("-")[0]
}

/**
 * The Link Resolver used for the Prismic repository. This function converts a
 * Prismic document to a URL within your app. It is used throughout your app to
 * resolve document links and support editor previews.
 *
 * {@link https://prismic.io/docs/technologies/link-resolver-gatsby}
 *
 * @param doc Prismic document to resolve to a URL within your app.
 *
 * @returns URL for the provided Prismic document.
 *
 * @type import('@prismicio/helpers').LinkResolverFunction
 */

exports.linkResolver = doc => {
  const prefix = getLangPrefix(doc.lang)
  const langPath = prefix ? `/${prefix}` : ""

  switch (doc.type) {
    case "homepage": {
      return prefix ? `/${prefix}` : "/"
    }

    case "page": {
      return prefix ? `${langPath}/${doc.uid}` : `/${doc.uid}`
    }

    case "blog": {
      return prefix ? `${langPath}/blogs/${doc.uid}` : `/blogs/${doc.uid}`
    }

    default:
      return prefix ? `/${prefix}` : "/"
  }
}

// Export helper function for use in other files
exports.getLangPrefix = getLangPrefix

// *****************************************
// *****************************************
// *****************************************

// console.log("-----Start---linkResolver.js-----")
// console.log("doc: ", doc)
// console.log("doc.type: ", doc.type)
// console.log("doc.data.category: ", doc.data.category)
// console.log("-----End---linkResolver.js-----")

// case "page": {
//   return doc.lang === defaultLanguage
//     ? doc.tags[0] !== undefined
//       ? `/${doc.tags[0]}/${doc.uid}`
//       : `/${doc.uid}`
//     : doc.tags[0] !== undefined
//     ? `/${doc.tags[0]}/${doc.lang}/${doc.uid}`
//     : `/${doc.lang}/${doc.uid}`
// }
